import { render, staticRenderFns } from "./fundDetails.vue?vue&type=template&id=8663c97e&scoped=true"
import script from "./fundDetails.vue?vue&type=script&lang=js"
export * from "./fundDetails.vue?vue&type=script&lang=js"
import style0 from "./fundDetails.vue?vue&type=style&index=0&id=8663c97e&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8663c97e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8663c97e')) {
      api.createRecord('8663c97e', component.options)
    } else {
      api.reload('8663c97e', component.options)
    }
    module.hot.accept("./fundDetails.vue?vue&type=template&id=8663c97e&scoped=true", function () {
      api.rerender('8663c97e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/new-column/column-k/form/fundDetails.vue"
export default component.exports